import { cva, type VariantProps } from 'class-variance-authority';

export const formFieldVariants = cva('rounded', {
    variants: {
        variation: {
            base: 'bg-gray-50 focus:bg-white border-gray-300 focus:ring-brand focus:border-brand',
            alt: 'bg-white border-gray-300 focus:ring-brand focus:border-brand',
            discrete: 'bg-transparent border-transparent hover:border-gray-300 focus:ring-brand focus:border-brand',
            highlighted: 'bg-brand-50 focus:bg-white border-gray-300 focus:ring-brand focus:border-brand',
        },
        disabled: {
            true: 'border-gray-200 focus:ring-brand focus:border-brand bg-gray-100',
        },
        error: {
            true: 'border-red-500 focus:ring-brand focus:border-brand',
        },
        centered: {
            true: 'text-center',
        },
    },
    defaultVariants: {
        variation: 'base',
    },
});

export type FormFieldVariants = VariantProps<typeof formFieldVariants>;
